import { Download, Plus, Upload } from 'lucide-react'

import { LoadingDropdownMenuItem } from '@fortem-monorepo/react-ui'
import { Button } from '@fortem-monorepo/react-ui'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@fortem-monorepo/react-ui'

import { useOpsContext } from '@/pages/operations/ops-context.context'
import { useDownloadMappingsTemplateMutation } from '@/react-query/mutations/mappings'
import { useMissingExternalMappings } from '@/react-query/queries/mappings'

export interface AddMappingButtonProps extends React.ComponentProps<typeof Button> {
  onDownloadTemplateClick?: () => void
}

export const AddMappingButton: React.FC<AddMappingButtonProps> = ({
  onDownloadTemplateClick,
  ...props
}) => {
  const context = useOpsContext()
  const missingMappingsQuery = useMissingExternalMappings()
  const missingMappings = missingMappingsQuery.data
  const downloadMappingsMutation = useDownloadMappingsTemplateMutation()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" {...props}>
          Add mappings
          <Plus />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          onClick={() => {
            context.createNewMapping()
          }}
        >
          Single entry
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            context.toggleUploadMappingsModal(true)
          }}
        >
          <Upload />
          Upload from files
        </DropdownMenuItem>
        <LoadingDropdownMenuItem
          disabled={missingMappingsQuery.isFetching || !missingMappings?.length}
          onClick={() => downloadMappingsMutation.mutateAsync()}
        >
          <Download />
          Download template
        </LoadingDropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
